export default{
  label:'margin-auto',
  isResponsive:true,
  xs:{
    valueScope:[
      'm-auto',
      'mx-auto',
      'my-auto',
      'ml-auto',
      'mr-auto',
      'mt-auto',
      'mb-auto',
    ],
  },
  sm:{
    valueScope:[
      'm-sm-auto',
      'mx-sm-auto',
      'my-sm-auto',
      'ml-sm-auto',
      'mr-sm-auto',
      'mt-sm-auto',
      'mb-sm-auto',
    ],
  },
  md:{
    valueScope:[
      'm-md-auto',
      'mx-md-auto',
      'my-md-auto',
      'ml-md-auto',
      'mr-md-auto',
      'mt-md-auto',
      'mb-md-auto',
    ],
  },
  lg:{
    valueScope:[
      'm-lg-auto',
      'mx-lg-auto',
      'my-lg-auto',
      'ml-lg-auto',
      'mr-lg-auto',
      'mt-lg-auto',
      'mb-lg-auto',
    ],
  },
  xl:{
    valueScope:[
      'm-xl-auto',
      'mx-xl-auto',
      'my-xl-auto',
      'ml-xl-auto',
      'mr-xl-auto',
      'mt-xl-auto',
      'mb-xl-auto',
    ],
  },
}//


// WEBPACK FOOTER //
// ./src/shell/schemas/utilities/flex/margin-auto.js